module.exports = __webpack_public_path__ + "img/food2.7425ad4f.jpg";